import React, { Component } from 'react'
import GetCreatorsPointsReport from '../../Services/Queries/GetCreatorsPointsReport'
import { Button, Table } from 'react-bootstrap'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import 'react-toastify/dist/ReactToastify.css'
import Spinner from '../header/Spinner'
import { creatorPointsReportHeadings } from '../Data/StaticData'
import _ from 'lodash'
const styles = {
    fontSize: {
        fontSize: '12px',
    },
}

class CreatorsPoints extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectionRange: {
                startDate: new Date(new Date().setHours(0, 0, 0, 0)),
                endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                key: 'selection',
            },
            showDatePickerAtStart: false,
            showDatePickerAtEnd: false,
            creatorsPointsList: [],
            headings: creatorPointsReportHeadings,
            // reportTypeOptions: [
            //     {
            //         label: 'creator',
            //         value: 'creator',
            //         id: 0,
            //     },
            //     {
            //         label: 'planner',
            //         value: 'planner',
            //         id: 1,
            //     },
            // ],
            // selectedReportType: 'creator',
            startDateChanged: false,
            endDateChanged: false,
            disableFilter: true,
            loading: true,
        }
    }

    componentDidMount = async () => {
        await this.GetCreatorsPointsReport()
    }

    GetCreatorsPointsReport = async () => {
        this.setState({ loading: true })
        const { selectionRange } = this.state
        const epochStartTime = selectionRange.startDate.getTime()
        const epochEndTime = selectionRange.endDate.getTime()
        const startTime = Math.trunc(epochStartTime / 1000)
        const endTime = Math.trunc(epochEndTime / 1000)

        // const input = {
        //     reportType: this.state.selectedReportType,
        // }
        const input = {
            fromTime: startTime,
            toTime: endTime,
            filterBy: 'month'
        }

        // if (this.state.startDateChanged || this.state.endDateChanged) {
        //     input['fromTime'] = startTime
        //     input['toTime'] = endTime
        //     input['filterBy'] = "month"

        // }
        console.log(input, 'input firstt========')
        const creatorsPointsList = await GetCreatorsPointsReport(input)
        console.log(creatorsPointsList.items, 'GetCreatorsPointsReport=====')
        this.setState({
            creatorsPointsList: creatorsPointsList.items, loading: false, disableFilter: true
        })
    }

    renderTable = (heading, creatorsList) => {
        return (
            <Table striped bordered hover>
                <thead>
                    <tr>
                        {heading.map((head) => (
                            <th style={{ fontSize: '12px', verticalAlign: 'middle' }}>{head}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {creatorsList && creatorsList.map((row, index) => this.renderTableRow(row, index))}
                </tbody>
            </Table>
        )
    }


    renderTableRow = (item, index) => {

        return (
            <tr style={styles.fontSize}>
                <td>{item.name}</td>
                <td>{item.handle}</td>
                <td>{item.creatorPoints}</td>
                <td>{item.creatorLikePoints}</td>
                <td>{item.creatorBookmarkPoints}</td>
                <td>{item.creatorPnOpensPoints}</td>
                <td>{item.creatorExtraArticlesPoints}</td>
                <td>{item.creatorTotalLikes}</td>
                <td>{item.creatorTotalBookmarks}</td>
                <td>{item.creatorTotalPnOpens}</td>
                <td>{item.creatorTotalContentsPublished}</td>
                <td>{item.plannerPoints}</td>
                <td>{item.plannerLikePoints}</td>
                <td>{item.plannerBookmarkPoints}</td>
                <td>{item.plannerPnOpensPoints}</td>
                <td>{item.plannerExtraArticlesPoints}</td>
                <td>{item.plannerTotalLikes}</td>
                <td>{item.plannerTotalBookmarks}</td>
                <td>{item.plannerTotalPnOpens}</td>
                <td>{item.plannerTotalContentsPublished}</td>
                <td>{item.PK}</td>
            </tr>
        )
    }

    openDatePickerAtStart = () => {
        this.setState({ showDatePickerAtStart: true, showDatePickerAtEnd: false })
    }

    openDatePickerAtEnd = () => {
        this.setState({ showDatePickerAtEnd: true, showDatePickerAtStart: false })
    }
    getFormattedDate = (date) => {
        var dd = date.getDate()
        var mm = date.getMonth() + 1
        var yyyy = date.getFullYear()
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        var formattedDate = dd + '/' + mm + '/' + yyyy
        var hh = date.getHours()
        var m = date.getMinutes()
        var d = 'AM'
        var h = hh
        if (h >= 12) {
            h = hh - 12
            d = 'PM'
        }
        if (h == 0) {
            h = 12
        }
        m = m < 10 ? '0' + m : m
        const formattedTime = h + ':' + m + ' ' + d
        return formattedDate + ' ' + formattedTime
    }

    resetFilter = () => {

        this.setState({
            startDateChanged: false,
            endDateChanged: false,
            selectionRange: {
                startDate: new Date(new Date().setHours(0, 0, 0, 0)),
                endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                key: 'selection',
            },
            // selectedReportType: 'creator',
            showDatePickerAtStart: false,
            showDatePickerAtEnd: false,
            disableFilter: true,
        })
        this.GetCreatorsPointsReport()
    }

    changeReportType = async (currentType, type) => {

        const { selectedReportType } = this.state
        if (currentType != type) {

            this.setState({ selectedReportType: type })
        }
    }
    handleStartDate = (dates) => {
        const start = new Date(dates.selection.startDate)
        start.setHours(0, 0, 0, 0)
        const end = new Date(dates.selection.endDate)
        end.setHours(23, 59, 59, 999)

        const dateObj = {
            startDate: start,
            endDate: end,
            key: 'selection',
        }
        this.setState({
            startDateChanged: true,
            endDateChanged: true,
            selectionRange: dateObj,
            showDatePickerAtStart: false,
            showDatePickerAtEnd: false,
            disableFilter: false,
        })

    }
    handleEndDate = (dates) => {
        const currentTime = new Date()
        const start = new Date(dates.selection.startDate)
        start.setHours(0, 0, 0, 0)
        const end = new Date(dates.selection.endDate)
        end.setHours(23, 59, 59, 999)
        if ((this.state.selectionRange.startDate.toString().split(':')[0] === currentTime.toString().split(':')[0]) || (this.state.selectionRange.startDate.getTime() > end)) {
            const dateObj = {
                startDate: start,
                endDate: end,
                key: 'selection',
            }
            this.setState({
                startDateChanged: true,
                endDateChanged: true,
                selectionRange: dateObj,
                showDatePickerAtEnd: false,
                showDatePickerAtStart: false,
                disableFilter: false,
            })
        }
        else {
            const dateObj = {
                startDate: this.state.selectionRange.startDate,
                endDate: end,
                key: 'selection',
            }
            this.setState({
                endDateChanged: true,
                selectionRange: dateObj,
                showDatePickerAtEnd: false,
                disableFilter: false,
            })
        }

    }
    render() {
        const {
            creatorsPointsList,
            headings,
            selectionRange,
            selectedReportType,
            reportTypeOptions,
            showDatePickerAtStart,
            showDatePickerAtEnd,
            loading,
        } = this.state
        return (
            <section className='feed'>
                {loading ?
                    <Spinner /> : null
                }
                <div>
                    <label>Creator Points</label>
                </div>
                <div>
                    <div class='row'>
                        <div class='col-md-4'>
                            <text>Start Date : </text>
                            <input
                                type='text'
                                onClick={() => {
                                    this.openDatePickerAtStart()
                                }}
                                value={this.getFormattedDate(selectionRange.startDate)}
                                placeholder='Choose Start Date'
                            ></input>

                        </div>

                        <div class='col-md-4'>
                            <text>End Date : </text>
                            <input
                                type='text'
                                onClick={() => {
                                    this.openDatePickerAtEnd()
                                }}
                                value={this.getFormattedDate(selectionRange.endDate)}
                                placeholder='Choose End Date'
                            ></input>

                        </div>
                        <div class='col-md-2'>
                            <Button
                                style={{ marginRight: 10 }}
                                onClick={() => {
                                    this.GetCreatorsPointsReport()
                                }}
                                disabled={this.state.disableFilter}
                            >
                                Filter
                            </Button>
                            <Button
                                onClick={() => {
                                    this.resetFilter()
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>
                    {/* <div class='row'>
                        <div class='col-md-4'>
                            <text htmlFor='userName'> Report Type : </text>
                            <div className='row'>
                                {reportTypeOptions.map((item, index) => (
                                    <div className='col-md-4' key={index}>
                                        <input
                                            value={selectedReportType}
                                            type='radio'
                                            checked={this.state.selectedReportType == item.value}
                                            onChange={() => {
                                                this.changeReportType(this.state.selectedReportType, item.value)
                                            }}
                                        ></input>
                                        <text for={item.label}>{item.label}</text>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div> */}
                    <div>
                        {showDatePickerAtStart ? (
                            <DateRangePicker ranges={[selectionRange]} onChange={this.handleStartDate} />
                        ) : null}
                        {showDatePickerAtEnd ? (
                            <DateRangePicker ranges={[selectionRange]} onChange={this.handleEndDate} />
                        ) : null}
                    </div>
                </div>


                {this.state.creatorsPointsList ? (
                    <div style={{ marginTop: 10 }}>{this.renderTable(headings, creatorsPointsList)}</div>
                ) : (
                    <div>No Data To Display</div>
                )
                }

            </section>
        )
    }
}

export default CreatorsPoints